
export class RequestStatus{
  code: number;
  msg:string;
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/pmclient-uat/src/app/shared/models/requestStatus.ts